// Renders a single qualification question exactly as a sales rep would see it.
// Pure presentational — receives one question object + value/onChange via props.
export default function PreviewField({ q, value, onChange, catOptions }) {
  const t = q.question_type;
  const opts = (q.options || []).map((o) => o.value).filter(Boolean);
  const base = "h-10 w-full rounded-lg border border-sky bg-white px-2.5 text-sm outline-none focus:border-loop focus:ring-2 focus:ring-loop/20";
  if (q.category_dependent) {
    return (
      <select className={base} value={value || ""} onChange={(e) => onChange(e.target.value || null)} data-testid={`preview-field-${q.question_id}`}>
        <option value="">Select…</option>
        {catOptions.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    );
  }
  if (t === "Single Select") {
    return (
      <select className={base} value={value || ""} onChange={(e) => onChange(e.target.value || null)} data-testid={`preview-field-${q.question_id}`}>
        <option value="">Select…</option>
        {opts.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    );
  }
  if (t === "Multi Select") {
    const arr = Array.isArray(value) ? value : [];
    return (
      <div className="flex flex-wrap gap-1.5" data-testid={`preview-field-${q.question_id}`}>
        {opts.map((o) => {
          const on = arr.includes(o);
          return <button key={o} type="button" onClick={() => onChange(on ? arr.filter((x) => x !== o) : [...arr, o])} className={`rounded-full border px-3 py-1 text-xs font-medium transition-colors ${on ? "border-loop bg-loop text-white" : "border-sky bg-white text-ink/70 hover:bg-mist"}`}>{o}</button>;
        })}
      </div>
    );
  }
  if (t === "Yes/No") {
    return (
      <div className="flex gap-2" data-testid={`preview-field-${q.question_id}`}>
        {["Yes", "No"].map((o) => <button key={o} type="button" onClick={() => onChange(o)} className={`flex-1 rounded-lg border px-3 py-2 text-sm font-medium transition-colors ${value === o ? "border-loop bg-loop text-white" : "border-sky bg-white text-ink/70 hover:bg-mist"}`}>{o}</button>)}
      </div>
    );
  }
  if (t === "Long Text") return <textarea rows={2} className="w-full rounded-lg border border-sky p-2.5 text-sm outline-none focus:border-loop focus:ring-2 focus:ring-loop/20" value={value || ""} onChange={(e) => onChange(e.target.value || null)} data-testid={`preview-field-${q.question_id}`} />;
  if (t === "Number" || t === "Currency") return <input type="number" className={base} value={value ?? ""} onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))} data-testid={`preview-field-${q.question_id}`} />;
  if (t === "Date") return <input type="date" className={base} value={value || ""} onChange={(e) => onChange(e.target.value || null)} data-testid={`preview-field-${q.question_id}`} />;
  return <input className={base} value={value || ""} onChange={(e) => onChange(e.target.value || null)} data-testid={`preview-field-${q.question_id}`} />;
}
